FinancesCtrl.$inject = []
function FinancesCtrl() {
  const vm = this
}

export default FinancesCtrl
